import { FILTER_TYPES } from 'pages/RideListPage/components/RideFilters/filterConstants';

import { LOCATIONS_FILTER_TEXT } from './texts';

/**
 * @typedef {object} CitySearchResult
 * @property {string} id
 * @property {string} name
 */

/**
 * @typedef {object} CityOption
 * @property {string} title
 * @property {string} key
 */

/**
 * @typedef {object} LocationConfig
 * @property {string} placeholder
 * @property {'fromCityIds' | 'toCityIds'} filterType
 */

/**
 * Map the raw `searchCitiesByName` response into autocomplete options.
 *
 * @param {CitySearchResult[] | null | undefined} cities
 * @returns {CityOption[]}
 */
export const mapCitiesToOptions = (cities) => {
	if (!cities) return [];
	return cities.map((city) => ({
		title: city.name,
		key: city.id,
	}));
};

/**
 * Pick the correct placeholder and filter type given the arrival/departure flag.
 *
 * @param {boolean} isArrival
 * @returns {LocationConfig}
 */
export const buildLocationConfig = (isArrival) => ({
	placeholder: isArrival
		? LOCATIONS_FILTER_TEXT.arrivalPlaceholder
		: LOCATIONS_FILTER_TEXT.departurePlaceholder,
	filterType: isArrival ? FILTER_TYPES.to : FILTER_TYPES.from,
});
